import { IDocDefinition } from '../models/doc-definition';
import { UploadedFile } from '../models/uploaded-file';

const getRequiredDocsTypes = <DocType extends string>(
  definitions: Array<IDocDefinition<DocType>>,
) =>
  definitions.reduce<Set<DocType>>((result, definition) => {
    if (!definition.isOptional) {
      result.add(definition.docType);
    }

    return result;
  }, new Set());

const getUploadedRequiredDocTypes = <DocType extends string>(
  uploadedDocTypes: DocType[],
  requiredDocTypes: Set<DocType>,
) => uploadedDocTypes.filter(docType => requiredDocTypes.has(docType));

const hasAllRequiredDocs = <DocType extends string>(
  uploads: Partial<Record<DocType, UploadedFile<DocType>>> | undefined,
  definitions: Array<IDocDefinition<DocType>>,
) => {
  if (!uploads || Object.values(uploads).length === 0) {
    return false;
  }

  const requiredDocTypes = getRequiredDocsTypes<DocType>(definitions);
  const uploadedDocsTypes = Object.keys(uploads) as DocType[];

  return Array.from(requiredDocTypes).every(docType => uploadedDocsTypes.includes(docType));
};

export { hasAllRequiredDocs, getUploadedRequiredDocTypes, getRequiredDocsTypes };
